import PropTypes from 'prop-types';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { ItemDisplayImage } from '../line-item/components/item-image.component';
import style from './style.module.css';

export const ProductTypeAheadInputResult = ({ name, sku, thumbnailUrl, isDisabled, disabledReason }) => {
  return (
    <FlexRow className={style['result-item']}>
      <ItemDisplayImage className={style['image-container']} name={name} productThumbnailUrl={thumbnailUrl} />
      <FlexColumn>
        <div className={style['product-name']} title={name}>
          {name}
        </div>
        <div className={style['product-sku']} title={sku}>
          {sku}
        </div>
        {isDisabled && disabledReason && (
          <div className={style['disabled-reason']} title={disabledReason}>
            {disabledReason}
          </div>
        )}
      </FlexColumn>
    </FlexRow>
  );
};

ProductTypeAheadInputResult.propTypes = {
  name: PropTypes.string.isRequired,
  sku: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string,
  isDisabled: PropTypes.bool,
  disabledReason: PropTypes.string,
};
